module.exports = __webpack_public_path__ + "img/D201403_1.ca2988c2.jpg";